export default __webpack_public_path__ + "static/sfx-bg_3-a1fd9e268034dff79ea618ecc50f94c4.png";